import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { withRouter, Link } from "react-router-dom";
import MediaQuery from 'react-responsive';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import LoginModal from './LoginModal';
import ApplyModal from './ApplyModal';
import Helmet from 'react-helmet';
import FillPartnerInformationPopup from './internal/Popups/FillPartnerInformationPopup';

import Parse from 'parse'

@inject('userStore')

@observer
class TopMenu extends Component {

  constructor(props) {
    super(props)
    this.state = {
      desktop: false
    };
    this.toggleDesktop = this.toggleDesktop.bind(this)
  }
  toggleDesktop() {
    this.setState({ desktop: !this.state.desktop })
  }
  // async componentWillMount() {
  //   const sessionToken = this.props.cookies.get('sessionToken')
  //   const redirectTo = this.props.location.pathname
  //
  //   //check if cookie
  //   if (sessionToken !== null) {
  //     await this.props.userStore.loginWithToken(sessionToken).then(res => {
  //       this.props.history.push(redirectTo);
  //     }).catch(err => {
  //       console.error("catch", err)
  //     })
  //     this.props.history.push(this.props.location.pathname);
  //   }
  // }

  handleSelect = (eventKey) => {
    const cookies = this.props.cookies;

    if (eventKey === 'logout') {
      this.props.userStore.logout()
      cookies.remove('parseSessionToken')
      this.props.history.push('/')
    } else if (eventKey === '#login' || eventKey === '#bewerben' || eventKey === '#share' || eventKey === '#toggleDesktop' || eventKey === '#toggleMobile') {
      //nix duan
    } else {
      this.props.history.push('/' + eventKey);
    }
  }

  onLoginClick = (data) => {
    this.loginmodal.openModal() // do stuff
  }

  onApplyClick = (data) => {
    this.applymodal.openModal() // do stuff
  }

  onShare = async () => {
    const config = await Parse.Config.get()
    if(navigator.share) {
      navigator.share({
        text: config.get("SHARE_TEXT"),
        url: config.get("SHARE_URL")
      })
    } else {
      // Fallback
      this.props.userStore.setShowSharePopup(true)
    }
  }

  render() {
    const { isLoggedIn } = this.props.userStore;
    return (
      <div>
        <Helmet>
          {this.state.desktop
            ? <meta name="viewport" content="width=1024" />
            : <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"></meta>
          }
        </Helmet>
        <LoginModal onRef={ref => (this.loginmodal = ref)} />
        <ApplyModal onRef={ref => (this.applymodal = ref)} />
        <Navbar
          fluid
          inverse
          collapseOnSelect={true}
          onSelect={this.handleSelect}>
          <Navbar.Header>
            <Link to="/"><Navbar.Brand>
              <img
                alt="lint.."
                src={require('../images/logo-menu.png')}
              />
            </Navbar.Brand></Link>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <MediaQuery query="(max-device-width: 1000px)">
              <Nav pullRight>
                {isLoggedIn &&
                  <NavItem eventKey={'internal/booking'}>JETZT BUCHEN</NavItem>}
                {/* {isLoggedIn &&
                  <NavItem eventKey={'residence'}>RESIDENCE</NavItem>} */}
                {isLoggedIn &&
                  <NavItem eventKey={'#share'} onClick={this.onShare} className="highlighted">TELL A FRIEND</NavItem>}
                {isLoggedIn &&
                  <NavItem eventKey={'rules'}>REGELWERK</NavItem>}
                {isLoggedIn &&
                  <NavItem eventKey={'internal'}>MEMBER AREA</NavItem>}
                {/* {isLoggedIn &&
                  <NavItem eventKey={'internal/offers'}>ANGEBOTE</NavItem>} */}
                {isLoggedIn &&
                  <NavItem eventKey={'partners'}>PARTNERS</NavItem>}
                {isLoggedIn &&
                  <NavItem eventKey={'logout'}>LOGOUT</NavItem>}
                {!isLoggedIn &&
                  <NavItem eventKey={'#login'} onClick={this.onLoginClick}>LOGIN</NavItem>}
                <div style={{ width: '80%', marginTop: 15,marginBottom: 15, borderBottom: '1px solid #DAB777' }}></div>
                {!this.state.desktop
                  ? <NavItem eventKey={'#toggleDesktop'} onClick={this.toggleDesktop}>DESKTOP-VIEW</NavItem>
                  : <NavItem eventKey={'#toggleMobile'} onClick={this.toggleDesktop}>MOBILE-VIEW</NavItem>}
                  <div style={{ width: '80%', marginTop: 15,marginBottom: 15, borderBottom: '1px solid #DAB777' }}></div>
                {!isLoggedIn &&
                  <NavItem eventKey={'#bewerben'} onClick={this.onApplyClick}>BEWERBEN</NavItem>}
                <NavItem eventKey={'impressum'}>IMPRESSUM</NavItem>
                <NavItem eventKey={'datenschutz'}>DATENSCHUTZ</NavItem>
                <NavItem eventKey={'kontakt'}>KONTAKT</NavItem>
                <div style={{ width: '80%', marginTop: 15,marginBottom: 15, borderBottom: '1px solid #DAB777' }}></div>
                  <NavItem eventKey={'backend/admin'}>CMS</NavItem>
                <div style={{ width: '80%', marginTop: 15,marginBottom: 15, borderBottom: '1px solid #DAB777' }}></div>

              </Nav>
            </MediaQuery>
            <MediaQuery query="(min-device-width: 1001px)">
              <Nav pullRight>
                {isLoggedIn &&
                  <NavItem eventKey={'internal/booking'}>JETZT BUCHEN</NavItem>}
                  {isLoggedIn &&
                    <NavItem eventKey={'#share'} onClick={this.onShare} className="highlighted">TELL A FRIEND</NavItem>}
                {/* {isLoggedIn &&
                  <NavItem eventKey={'residence'}>RESIDENCE</NavItem>} */}
                {isLoggedIn &&
                  <NavItem eventKey={'rules'}>REGELWERK</NavItem>}
                {isLoggedIn &&
                  <NavItem eventKey={'internal'}>MEMBER AREA</NavItem>}
                {/* {isLoggedIn &&
                  <NavItem eventKey={'internal/offers'}>ANGEBOTE</NavItem>} */}
                {isLoggedIn &&
                  <NavItem eventKey={'partners'}>PARTNERS</NavItem>}
                {isLoggedIn &&
                  <NavItem eventKey={'logout'}>LOGOUT</NavItem>}
                {!isLoggedIn &&
                  <NavItem eventKey={'#login'} onClick={this.onLoginClick}>LOGIN</NavItem>}
                {!isLoggedIn &&
                  <NavItem eventKey={'#bewerben'} onClick={this.onApplyClick}>BEWERBEN</NavItem>}
              </Nav>
            </MediaQuery>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }
}
TopMenu.propTypes = {
  userStore: MobxPropTypes.observableObject,
  cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(TopMenu));



// WEBPACK FOOTER //
// /src/components/TopMenu.js